import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LandingComponent } from './landing/landing.component';
import { SigninComponent } from './users/signin/signin.component';
import { SignupComponent } from './users/signup/signup.component';
import { VerificationSuccessfulComponent } from './users/verification-successful/verification-successful.component';
import { ProfileComponent } from './users/profile/profile.component';
import { ForgotPasswordComponent } from './users/forgot-password/forgot-password.component';
import { PasswordResetEmailSentComponent } from './users/password-reset-email-sent/password-reset-email-sent.component';
import { ResetPasswordComponent } from './users/reset-password/reset-password.component';
import { ResetPasswordSuccessComponent } from './users/reset-password-success/reset-password-success.component';
import { SignupSuccessfulComponent } from './users/signup-successful/signup-successful.component';

import { ProjectComponent } from './project/project.component';
import { BookmarksComponent } from './bookmarks/bookmarks.component';
import { ReferencesComponent } from './references/references.component';
import { CanvasComponent } from './canvas/canvas.component';

const routes: Routes = [
  
  	{ path: 'landing', component: LandingComponent },
  	{ path: '',   redirectTo: '/landing', pathMatch: 'full' },
  	{ path: 'signin', component: SigninComponent },
	{ path: 'signup', component: SignupComponent },
	{ path: 'signup-successful', component: SignupSuccessfulComponent}, 
	{ path: 'verification-status', component: VerificationSuccessfulComponent },
	{ path: 'forgot-password', component: ForgotPasswordComponent },
	{ path: 'reset-email-sent', component: PasswordResetEmailSentComponent },
	{ path: 'reset-password', component: ResetPasswordComponent },
	{ path: 'reset-password-success', component: ResetPasswordSuccessComponent },
	{ path: 'profile', component: ProfileComponent },
	{ path: 'projects', component: ProjectComponent },
	{ path: 'bookmarks', component: BookmarksComponent },
	{ path: 'references', component: ReferencesComponent },
	{ path: 'editor/:id/:status', component: CanvasComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
